import defaultStory from '../defaults/story.json';

const DB_NAME = 'tvain';
const DB_VERSION = 1;
const STORE = 'projects';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'id' });
      }
    };
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror = (e) => reject(e.target.error);
  });
}

function idbUuid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}

export const indexedDBBackend = {
  async account(_token) {
    return { status: 2, message: 'Authentication successful' };
  },

  async register(_email) {
    return { status: 1, message: 'Sent' };
  },

  async projects(_token) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).getAll();
      req.onsuccess = () =>
        resolve({ projects: req.result.map((p) => ({ id: p.id, name: p.projectName })) });
      req.onerror = () => reject(req.error);
    });
  },

  async load(_token, id) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).get(id);
      req.onsuccess = () => {
        if (req.result) resolve(req.result.story);
        else reject(new Error('Project not found'));
      };
      req.onerror = () => reject(req.error);
    });
  },

  async save(_token, id, data) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      const store = tx.objectStore(STORE);
      const getReq = store.get(id);
      getReq.onsuccess = () => {
        if (!getReq.result) { reject(new Error('Project not found')); return; }
        const putReq = store.put({ ...getReq.result, story: JSON.parse(JSON.stringify(data)) });
        putReq.onsuccess = () => resolve({ success: 1 });
        putReq.onerror = () => reject(putReq.error);
      };
      getReq.onerror = () => reject(getReq.error);
    });
  },

  async delete(_token, id) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      const req = tx.objectStore(STORE).delete(id);
      req.onsuccess = () => resolve({ status: 1, message: 'Project deleted' });
      req.onerror = () => reject(req.error);
    });
  },

  async addproject(_user, projectName, projectDescription) {
    const db = await openDB();
    const id = idbUuid();
    const story = JSON.parse(JSON.stringify(defaultStory));
    story.project.name = projectName;

    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      const req = tx.objectStore(STORE).add({ id, projectName, projectDescription, story });
      req.onsuccess = () => resolve({ status: 1, message: 'Project created' });
      req.onerror = () => reject(req.error);
    });
  },
};
